/**
 * Backend routes live under /api/**. VITE_API_BASE_URL should be like https://host/api.
 * If Railway is set to https://host only, requests become /auth/login instead of /api/auth/login and CORS fails.
 */
export function normalizeProductionApiBaseUrl(raw: string): string {
  const trimmed = raw.trim().replace(/\/+$/, '')
  if (trimmed.endsWith('/api')) return trimmed
  return `${trimmed}/api`
}

function readConfiguredApiBaseUrl(): string | undefined {
  const base = import.meta.env.VITE_API_BASE_URL?.trim()
  if (base) return base
  // Legacy name used in .env.staging and older docs/scripts.
  const legacy = import.meta.env.VITE_API_URL?.trim()
  return legacy || undefined
}

/** Base URL for API calls (dev proxy path or production URL ending with /api). */
export function getApiBaseUrl(): string {
  const configured = readConfiguredApiBaseUrl()

  if (import.meta.env.MODE === 'development') {
    // Default: /api → Vite proxy → local backend.
    // Optional: set VITE_API_BASE_URL=https://your-api.up.railway.app/api to hit remote API from local dev.
    if (configured && /^https:\/\//i.test(configured)) {
      return normalizeProductionApiBaseUrl(configured)
    }
    return '/api'
  }

  return normalizeProductionApiBaseUrl(configured || 'http://localhost:8080/api')
}
